import {
  CHANGE_ACTIVE_ITEM_HOME, CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_LOG, CHANGE_ACTIVE_ITEM_CONFIG, CHANGE_ACTIVE_ITEM_INVENTORY,
  CHANGE_ACTIVE_ITEM_PORTS, CHANGE_ACTIVE_ITEM_MEDIA, CHANGE_ACTIVE_ITEM_INTERFACE,
  CHANGE_ACTIVE_ITEM_NETWORK, CHANGE_ACTIVE_PING_GRAPH, CHANGE_ACTIVE_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY,SOLVE_PROBLEM
} from "../actions/types";

// ---- Actions ----
export function homeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_HOME,
    payload: { activeItem: "/" }
  };
}

export function livelistAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST,
    payload: { activeItem: "/livelist" }
  };
}

export function graphicTopologyAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY,
    payload: { activeItem: "/graphic-topology" }
  };
}

export function logAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LOG,
    payload: { activeItem: "/log" }
  };
}

export function configAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_CONFIG,
    payload: { activeItem: "/config" }
  };
}

export function inventoryAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_INVENTORY,
    payload: { activeItem: "/inventory" }
  };
}

export function portsAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PORTS,
    payload: { activeItem: "/ports" }
  };
}

export function mediaCountersAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_MEDIA,
    payload: { activeItem: "/mediaCounters" }
  };
}

export function interfaceCountersAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_INTERFACE,
    payload: { activeItem: "/interfaceCounters" }
  };
}

export function networkAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_NETWORK,
    payload: { activeItem: "/network" }
  };
}

export function pingGraphAction() {
  return {
    type: CHANGE_ACTIVE_PING_GRAPH,
    payload: { activeItem: "/pingGraph" }
  };
}

export function topologyAction() {
  return {
    type: CHANGE_ACTIVE_TOPOLOGY,
    payload: { activeItem: "/topology" }
  };
}

export function solveProblemAction(solve, problem) {
  return {
    type: SOLVE_PROBLEM,
    payload: {
      solve: solve,
      problem: problem
    }
  };
}